/* MSM AV article enhancements: contents list, reading progress, table wrappers */
(function () {
  function slug(s) {
    return (s || '').toLowerCase().replace(/&[a-z]+;/g, '').replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60) || 'section';
  }

  function init() {
    var article = document.querySelector('[data-mbx-article]');
    var prose = document.querySelector('[data-mbx-prose]');
    if (!article || !prose) return;

    /* 1. wrap tables so they scroll on small screens */
    prose.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('mbx-table')) return;
      var w = document.createElement('div');
      w.className = 'mbx-table';
      w.setAttribute('tabindex', '0');
      w.setAttribute('role', 'region');
      w.setAttribute('aria-label', 'Table');
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
      var hint = document.createElement('p');
      hint.className = 'mbx-table-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = 'Swipe to see more <span>&rarr;</span>';
      w.parentNode.insertBefore(hint, w);
      var check = function () {
        var more = w.scrollWidth > w.clientWidth + 4;
        var atEnd = w.scrollLeft + w.clientWidth >= w.scrollWidth - 4;
        hint.classList.toggle('is-on', more && !atEnd);
        w.classList.toggle('is-scrollable', more);
      };
      w.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      window.addEventListener('load', check);
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(w);
      setTimeout(check, 600);
      check();
    });

    /* 2. contents list from the h2s (skip headings inside boxed call-outs) */
    var used = {};
    var heads = Array.prototype.filter.call(prose.querySelectorAll('h2'), function (h) {
      if (!h.textContent.trim()) return false;
      var p = h.parentElement;
      while (p && p !== prose) {
        if (p.getAttribute('style') && /background/i.test(p.getAttribute('style'))) return false;
        p = p.parentElement;
      }
      return true;
    });

    if (heads.length >= 3) {
      var items = heads.map(function (h) {
        if (!h.id) {
          var id = slug(h.textContent);
          while (used[id] || document.getElementById(id)) id += '-x';
          h.id = id;
        }
        used[h.id] = true;
        return { id: h.id, text: h.textContent.trim() };
      });

      var lists = article.querySelectorAll('[data-mbx-toc] .mbx-toc__list, [data-mbx-toc-m] .mbx-toc__list');
      lists.forEach(function (ol) {
        items.forEach(function (it) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + it.id;
          a.textContent = it.text;
          a.setAttribute('data-target', it.id);
          li.appendChild(a);
          ol.appendChild(li);
        });
      });
      article.querySelectorAll('[data-mbx-toc], [data-mbx-toc-m]').forEach(function (el) { el.hidden = false; });

      /* the hand-written "Jump to:" box duplicates the list, so hide it */
      prose.querySelectorAll('p').forEach(function (p) {
        var t = p.textContent.trim();
        if (/^jump to\s*:/i.test(t) && p.querySelectorAll('a[href^="#"]').length >= 2) p.classList.add('mbx-jump');
      });

      /* close the mobile list after choosing a section */
      var mob = article.querySelector('[data-mbx-toc-m]');
      if (mob) mob.addEventListener('click', function (e) { if (e.target.closest('a')) mob.open = false; });

      /* highlight the section being read */
      var links = article.querySelectorAll('[data-mbx-toc] a[data-target]');
      if ('IntersectionObserver' in window && links.length) {
        var current = null;
        var setActive = function (id) {
          if (id === current) return;
          current = id;
          links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-target') === id); });
        };
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
        }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
        heads.forEach(function (h) { io.observe(h); });
      }
    }

    /* 3. reading progress */
    var bar = document.querySelector('.mbx-progress__bar');
    if (bar) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var r = prose.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.6;
        var done = Math.min(Math.max(-r.top + window.innerHeight * 0.2, 0), Math.max(total, 1));
        bar.style.transform = 'scaleX(' + (done / Math.max(total, 1)).toFixed(4) + ')';
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
